document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.news-feed-listing').forEach((listingDiv) => {
    let rssSource = listingDiv.getAttribute('data-wf-news-source');
    let count = listingDiv.getAttribute('data-wf-news-count');
    let tmpl = listingDiv.querySelector('.wf-news-template').content;
    let list = listingDiv.querySelector('.fbhs-listing');

    fetch('/wp-json/wf/v1/news')
      .then((response) => response.json())
      .then(data => {
        data.forEach((item, ind) => {
          if (ind < count) {
            let view = tmpl.cloneNode(true);

            view.querySelector('.post-date').innerHTML = item.date;
            let title = view.querySelector('.listing-item-title');
            title.setAttribute('href', item.link);
            title.innerHTML = item.title;
            list.appendChild(view);
          }
        })
      })
      .catch(e => console.log(e));
  })
})
